/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersenabledescription2Inputs */

const en_membersenabledescription2 = /** @type {(inputs: Membersenabledescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People ask on your page in the app to become a member, and you accept them. Your events then also get the option “Members only”.`)
};

const de_membersenabledescription2 = /** @type {(inputs: Membersenabledescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leute fragen auf deiner Seite in der App an, Mitglied zu werden, und du nimmst sie an. Bei deinen Events gibt es dann zusätzlich „Nur Mitglieder“.`)
};

/**
* | output |
* | --- |
* | "People ask on your page in the app to become a member, and you accept them. Your events then also get the option “Members only”." |
*
* @param {Membersenabledescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersenabledescription2 = /** @type {((inputs?: Membersenabledescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersenabledescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersenabledescription2(inputs)
	return de_membersenabledescription2(inputs)
});
export { membersenabledescription2 as "membersEnableDescription" }